// removed by extract-text-webpack-plugin
module.exports = {"name":"styles__name___s9_nB","rotate":"styles__rotate___1tIz0","fadein":"styles__fadein___11Y2_","slideFromRight":"styles__slideFromRight___UPn6N","waves":"styles__waves___Jhjiu"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/Labels/styles.scss
// module id = ./resources/assets/js/components/Labels/styles.scss
// module chunks = 0